<template>
  <FormComponent class="register" @submit="register">
    <h3 class="auth-title">
      <!-- <button class="btn" type="button" @click="back()">
        <span class="material-icons-outlined">arrow_back</span>
      </button> -->
      {{ $t('app.register') }}
    </h3>
    <p style="color: lightslategray">{{ $t('auth.slogan') }}</p>
    <div class="row center">
      <div class="col-md-6">
        <InputComponent :label="$tc('app.name', 1)" name="name" :placeholder="$tc('app.name', 1)" required v-model="form.name"></InputComponent>
      </div>
      <div class="col-md-6">
        <InputComponent :label="$tc('app.company', 1)" name="company" :placeholder="$t('app.company')" required v-model="form.account_name"></InputComponent>
      </div>
      <div class="col-md-12">
        <TelInputComponent :label="$tc('app.phone', 1)" v-model="form.mobile_number" required></TelInputComponent>
      </div>
      <div class="col-md-6">
        <InputComponent name="email" type="email" :label="$tc('app.email', 1)" :placeholder="$t('app.email')" required v-model="form.email"></InputComponent>
      </div>
      <div class="col-md-6">
        <PasswordInputComponent :label="$tc('app.password', 1)" :placeholder="$t('login-invite.fullname')" required v-model="form.password"></PasswordInputComponent>
      </div>
    </div>
    <CheckboxComponent v-model="terms" required
      >Li e concordo com os
      <a id="show-btn" href="javascript:void(0)" @click="showModal()">termos de uso</a>
      <b-modal ref="my-modal" size="xl" scrollable hide-footer title="Termos">
        <div class="container-fluid">
          <ModalContentTerms />
        </div>
      </b-modal>
    </CheckboxComponent>
    <ButtonComponent type="submit" is-block :loading="isSending">{{ $t('app.register') }}</ButtonComponent>
    <div class="row justify-content-center">
      <p class="already-registered">{{ $t('auth.already-have-account') }}</p>
      <router-link to="/login" class="login">{{ $t('app.login') }}</router-link>
    </div>
    <div class="mb-4" v-if="false">
      <SeparatorComponent text="Ou continue com" />
      <div class="d-flex align-items-center justify-content-center social-group">
        <GoogleButtonComponent @login="handleGoogleLogin"></GoogleButtonComponent>
        <FacebookButtonComponent @login="handleFacebookLogin"></FacebookButtonComponent>
      </div>
    </div>
  </FormComponent>
  <!--</form>-->
</template>

<script>
// @ is an alias to /src
import User from '@/models/user';
import { load } from 'recaptcha-v3';
import ModalContentTerms from '@/components/rebranding/ModalContentTerms.vue';
import FormComponent from '../../components/form/FormComponent.vue';
import InputComponent from '../../components/form/InputComponent.vue';
import TelInputComponent from '../../components/form/TelInputComponent.vue';
import PasswordInputComponent from '../../components/form/PasswordInputComponent.vue';
import CheckboxComponent from '../../components/form/CheckboxComponent.vue';
import ButtonComponent from '../../components/ui/ButtonComponent.vue';
import SeparatorComponent from '../../components/ui/SeparatorComponent.vue';
import GoogleButtonComponent from '../../components/ui/GoogleButtonComponent.vue';
import FacebookButtonComponent from '../../components/ui/FacebookButtonComponent.vue';

export default {
  name: 'Register',
  components: {
    ModalContentTerms,
    FormComponent,
    InputComponent,
    TelInputComponent,
    PasswordInputComponent,
    CheckboxComponent,
    ButtonComponent,
    SeparatorComponent,
    GoogleButtonComponent,
    FacebookButtonComponent,
  },
  computed: {
    isMainWhitelabel() {
      return this.$store.state?.admin?.whitelabel?.['is_main'];
    },
  },
  data() {
    return {
      user: new User('', ''),
      terms: false,
      isSending: false,
      isSendingGoogle: false,
      isSendingFacebook: false,
      countries: [],
      mobile_number: null,
      invalidPhone: false,
      valid_password: false,
      form: {
        name: '',
        account_name: '',
        email: '',
        mobile_number: '',
        password: '',
      },
      bindProps: {
        mode: 'international',
        defaultCountry: 'BR',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: true,
        placeholder: this.$t('generic-str.lbl-cellphone'),
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        validCharactersOnly: true,
        preferredCountries: ['AU', 'BR'],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: 'off',
        name: 'telephone',
        maxLen: 25,
        wrapperClasses: '',
        inputClasses: 'form-control',
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
    };
  },
  mounted() {
    if (window.location.hostname !== 'localhosts' && window.location.hostname !== 'app.yup.chat') {
      const el = this.$el;
      el.style.setProperty('--clr-yup-light-purple', '#e6e6e6');
      el.style.setProperty('--clr-yup-whitelabel-label', 'grey');
    }
  },
  methods: {
    back() {
      this.$parent.routing = false;
      this.$router.back();
    },
    recaptcha(callback) {
      load(process.env.VUE_APP_RECAPTCHA_KEY, {
        useRecaptchaNet: true,
        autoHideBadge: true,
      }).then((recaptcha) => {
        recaptcha.execute('register').then((token) => {
          this.form.recaptcha_token = token;
          callback();
        });
      });
    },
    register() {
      this.isSending = true;
      this.recaptcha(() => {
        this.$store
          .dispatch('auth/register', this.form)
          .then(() => {
            localStorage.setItem('registrationSuccess', true);
            this.$router.push('/success');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.show({
              title: this.$t('sms.infos.filters.status.lbl-error'),
              content: error.response?.data?.message || 'Erro inesperado',
              type: 'danger',
            });
            this.isSending = false;
          });
      });
    },
    loginRedirect() {
      this.$store.dispatch('auth/login', this.form).then(
        (response) => {
          console.log(response);
          this.isSending = false;
          this.$router.push('/');
        },
        (error) => {
          this.$toast.show({
            title: this.$t('sms.infos.filters.status.lbl-error'),
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
    showModal() {
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn');
    },
    handleGoogleLogin(response) {
      this.$store.dispatch('auth/loginWithGoogle', response).then(() => {
        this.$live.firstLaunch = true;
        this.$router.push('/');
      });
    },
    handleFacebookLogin(response) {
      this.$store.dispatch('auth/loginWithFacebook', response).then(() => {
        this.$live.firstLaunch = true;
        this.$router.push('/');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.social-group {
  gap: 16px;
}

.auth-title {
  font-size: 36px;
  margin-bottom: 26px;

  .btn {
    padding: 0;
    font-size: 24px;
  }
}

.already-registered {
  color: var(--clr-yup-purple);
  font-size: 14px;
  margin-left: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.login {
  color: var(--clr-yup-purple);
  text-decoration: underline;
  font-size: 14px;
  margin-left: 3px;
  font-weight: 600;
}

::v-deep .form-group {
  label {
    color: var(--clr-yup-whitelabel-label) !important;
    margin-bottom: 0.32rem !important;
    font-size: 0.785rem !important;
  }
}

::v-deep .form-group {
  label {
    span {
      display: none;
    }
  }
}

::v-deep .form-group {
  .form-control {
    border: 2px solid var(--clr-yup-light-purple);
    padding: 10px 15px !important;
  }

  input[type='tel'] {
    border-right: 2px solid var(--clr-yup-light-purple) !important;
    border-radius: 0px 10px 10px 0px !important;
  }

  .material-icons-outlined {
    color: gainsboro !important;
  }

  .v-select {
    .vs__dropdown-toggle {
      border-color: var(--clr-yup-light-purple);
    }
  }
}

::v-deep .primary {
  height: 53px !important;
  font-weight: 600 !important;
}

::v-deep .btn-icon {
  border: 1px 1px 1px 0px;
  border-color: var(--clr-yup-light-purple) !important;
}

::v-deep .dropdown-toggle {
  border: 1px 1px 1px 0px;
  border-color: var(--clr-yup-light-purple) !important;
}

::v-deep .form-group {
  .v-select {
    .vs__dropdown-toggle {
      input {
        font-size: 14.3px !important;
        color: #c6cdde !important;
      }
    }
  }
}

::v-deep .separator::before,
::v-deep .separator::after {
  border-top: 2px solid var(--clr-yup-light-purple) !important;
}

::v-deep .separator {
  span {
    margin: 0px 10px;
    font-size: 15px;
  }
}

::v-deep .google-btn {
  width: 202px;
  border: 2px solid rgba(117, 45, 230, 0.16) !important;
  margin-bottom: 0px !important;
  &:hover {
    background-color: rgba(117, 45, 230, 0.16) !important;
  }
}

::v-deep .facebook-btn {
  width: 202px;
  border: 2px solid rgba(117, 45, 230, 0.16) !important;
  margin-bottom: 0px !important;
  &:hover {
    background-color: rgba(117, 45, 230, 0.16) !important;
  }
  background-color: white !important;
  i {
    color: #1877f2 !important;
  }
}

h3,
p {
  text-align: center;
}
</style>
